export default __webpack_public_path__ + "static/media/Search_Pin.e88a4d93.svg";